const KEY_TEEN = 'sc_age_confirmed_13';
const KEY_MATURE = 'sc_age_confirmed_18';

export const AgeConfirm = {
  isConfirmed(rating: string): boolean {
    const r = rating.toUpperCase();
    if (r === 'M') return localStorage.getItem(KEY_MATURE) === '1';
    if (r === 'T') return localStorage.getItem(KEY_TEEN) === '1' || localStorage.getItem(KEY_MATURE) === '1';
    return true;
  },
  confirm(rating: string): void {
    const r = rating.toUpperCase();
    if (r === 'M') {
      localStorage.setItem(KEY_MATURE, '1');
      localStorage.setItem(KEY_TEEN, '1');
    } else if (r === 'T') {
      localStorage.setItem(KEY_TEEN, '1');
    }
  },
};
